import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHokodo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m 1.3937342,12 c 0,-3.8844108 0,-7.7688252 0,-11.65323666 1.9422061,0 3.884412,0 5.8266192,0 0,2.89813536 0,5.79627226 0,8.69440486 -0.5917662,0 -1.1835338,0 -1.775299,0 0,1.9725548 0,3.9451078 0,5.9176608 0.5917652,0 1.1835328,0 1.775299,0 0,2.898136 0,5.796273 0,8.694408 -1.9422072,0 -3.8844131,0 -5.8266193,0 0,-3.884413 0,-7.768825 10e-8,-11.653237 z m 15.3859128,7.306033 c 0,-1.449068 0,-2.898134 0,-4.347204 -2.518797,0 -5.037597,0 -7.5563951,0 0,-1.972553 0,-3.945106 0,-5.9176608 2.5187981,0 5.0375981,0 7.5563951,0 0,-2.8981326 0,-5.7962695 0,-8.69440486 1.942206,0 3.884413,0 5.826619,0 0,7.76882586 0,15.53764866 0,23.30647366 -1.942206,0 -3.884413,0 -5.826619,0 0,-1.449067 0,-2.898135 0,-4.347204 z" })
});
export default SvgHokodo;
